import { ApiRoute } from "PFCore/utilities/routes";

export const fetchProfilesCount = (skill: { id: number }) =>
  /* @ts-ignore */
  $.ajax({
    url: ApiRoute("/api/profiles"),
    data: {
      filters: {
        strings: {
          skills: [skill.id]
        }
      },
      page: 1,
      per_page: 0
    },
    api_version: 2
  });

export const fetchRolesCount = (
  roleTemplate: { id: number; key: string } | undefined,
  skill: { id: number }
) =>
  /* @ts-ignore */
  $.ajax({
    url: ApiRoute("/api/activities"),
    data: {
      filters: {
        fields: {
          template_key: roleTemplate ? roleTemplate.key : null,
          state: ["draft", "new"]
        },
        strings: {
          skills: [skill.id]
        }
      },
      page: 1,
      per_page: 0
    },
    api_version: 2
  });

export const fetchProfilesList = (profilesList: string[]) =>
  /* @ts-ignore */
  $.ajax({
    url: ApiRoute("/api/profiles"),
    api_version: 2,
    data: { filters: { fields: { id: profilesList } }, page: 1, per_page: 20, full: true }
  });

export const fetchReportsFilters = () =>
  /* @ts-ignore */
  $.ajax({
    url: ApiRoute("/api/reports/filters?report_type=activities"),
    api_version: 2
  });
